import axios from 'axios';
import routes from '../app/routes';

export const teamCoachPoolActions = {
  loadCoaches: (dispatch, team) => {
    axios
      .get(routes.api.coaches.index, {
        params: {
          team_id: team.id,
        },
      })
      .then((resp) => {
        dispatch({ type: 'loadCoaches', coaches: resp.data.data });
      });
  },
  assignCoachPool: (dispatch, team, poolId, successCallback, errorCallback) => {
    axios
      .post(routes.api.teams.assign_coach_pool(team.id), {
        coach_pool_id: poolId,
      })
      .then((resp) => {
        dispatch({ type: 'assignCoachPool', team: resp.data.data });
        successCallback();
      })
      .catch((error) => {
        if (error.response && error.response.status == 422) {
          const data = [];
          error.response.data.errors.forEach((error) => {
            data.push(error.detail);
          });
          errorCallback(data.join('.'));
        }
      });
  },
  removeCoachPool: (dispatch, team, successCallback, errorCallback) => {
    axios
      .post(routes.api.teams.remove_coach_pool(team.id))
      .then((resp) => {
        dispatch({ type: 'assignCoachPool', team: resp.data.data });
        successCallback();
      })
      .catch((error) => {
        if (error.response && error.response.status == 422) {
          const data = [];
          error.response.data.errors.forEach((error) => {
            data.push(error.detail);
          });
          errorCallback(data.join('.'));
        }
      });
  },
};
